import { render } from "./right-narrow.svg?vue&type=template&id=66db6ab9"
const script = {}

import exportComponent from "/buddy/derek-lam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__